import React from 'react';
import { Button, ButtonProps, mergeClasses } from '@fluentui/react-components';
import './GuideComponents.css';

/**
 * Botón "Link / sutil" de la guía: sin borde ni fondo, texto primario bold (oscuro: acento,
 * alto contraste: amarillo). Para acciones secundarias dentro del contenido ("Ver detalle", "Quitar selección").
 */
export const GuideLinkButton = (props: ButtonProps) => (
  <Button {...props} appearance="transparent" className={mergeClasses('ichtys-link-button', props.className)} />
);

/**
 * Acción de un banner (`GuideMessageBar`): texto subrayado en el color del banner, a la derecha
 * ("Completar", "Reintentar"). Va dentro de `MessageBarActions`.
 */
export const GuideBannerAction = (props: ButtonProps) => (
  <Button {...props} appearance="transparent" className={mergeClasses('ichtys-banner-action', props.className)} />
);
